import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { messageSchema } from './schemas/message-schema';

export function getVehicleGroupsRoutingProfiles(vehicleGroupId: number) {
  return fromFetch(
    new Request(
      fleetEnvironment.vehicleGroupsRoutingProfilesUrl(String(vehicleGroupId)),
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
      }
    )
  ).pipe(
    selectData(
      messageSchema.extend({
        data: z.array(z.number()),
      })
    )
  );
}
